/**
 * 마크다운 문서 URL 상수 (여기서만 관리)
 */
export const MARKDOWN_URLS = {
  RELEASE_NOTE: 'https://raw.githubusercontent.com/kickbell/meeting-room-booking-releasenote/main/README.md',
  SUBSCRIBE_CALENDAR_GUIDE: 'https://raw.githubusercontent.com/kickbell/meeting-room-booking-releasenote/main/SUBSCRIBE_CALENDAR_GUIDE.md',
  UPCOMING_FEATURES: 'https://raw.githubusercontent.com/kickbell/meeting-room-booking-releasenote/main/UPCOMING_FEATURES.md',
} as const;

/**
 * 공개 URL에서 마크다운 파일을 가져오는 함수
 *
 * @param key MARKDOWN_URLS의 키 (예: 'RELEASE_NOTE')
 * @returns 마크다운 콘텐츠
 */
export const getMarkdownContent = async (key: keyof typeof MARKDOWN_URLS): Promise<string> => {
  try {
    const url = MARKDOWN_URLS[key];
    if (!url) {
      return '# 지원하지 않는 문서입니다.';
    }
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error('마크다운 파일을 불러올 수 없습니다.');
    }
    const content = await response.text();
    return content;
  } catch (error) {
    console.error('마크다운 콘텐츠 가져오기 오류:', error);
    return '# 콘텐츠를 불러올 수 없습니다\n\n오류가 발생했습니다. 나중에 다시 시도해주세요.';
  }
};
